import * as React from 'react';
import { Box, Button, Typography } from '@mui/material';

export const ZoneFeedback = (props: { handleRequestService: Function }) => {
  return (
    <Box sx={{ textAlign: 'center' }}>
      <Typography variant="subtitle2" style={{ marginBottom: 10 }}>
        How would you rate the cleanliness?
      </Typography>
      <Button variant="contained" onClick={() => props.handleRequestService()}>
        Request A Service
      </Button>
    </Box>
  );
};
